import { Injectable } from '@angular/core';
import { LMFormState } from '@states/models';
import { LMStatePersistenceService } from '@services/lm-state-persistence.service';

@Injectable()
export class LMFormStateService {
  constructor(private lmStatePersistenceService: LMStatePersistenceService) {
  }

  public getFormState(formStateKeyParams: LMFormStateKeyParams): LMFormState {
    return this.lmStatePersistenceService.getState(formStateKeyParams.key);
  }

  public saveFormState(formStateKeyParams: LMFormStateKeyParams, formStateItem: LMFormState): void {
    this.lmStatePersistenceService.persistState(formStateKeyParams.key, formStateItem);
  }

  public deleteFormState(formStateKeyParams: LMFormStateKeyParams): void {
    this.lmStatePersistenceService.removeState(formStateKeyParams.key);
  }
}

export class LMFormStateKeyParams {
  actorId?: string;
  asOfDate?: string;
  dataArea: string;
  routeResourceId: string;
  resourceId: string;

  private _key = '';

  get key() {
    if (!this._key) {
      this.buildKey();
    }
    return this._key;
  }

  private buildKey(): void {
    const stringArray = new Array<string>();

    if (this.actorId) {
      stringArray.push(this.actorId);
    }
    if (this.asOfDate) {
      stringArray.push(this.asOfDate);
    }

    stringArray.push(this.dataArea);
    stringArray.push(this.routeResourceId);

    if (this.resourceId !== this.routeResourceId) {
      // must be a formPanel
      stringArray.push(this.resourceId);
    }

    this._key = stringArray.join('_');
  }
}
